import { render } from "./TheProfessionalResourcesList.vue?vue&type=template&id=6b8d9c66&ts=true"
import script from "./TheProfessionalResourcesList.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalResourcesList.vue?vue&type=script&lang=ts"

import "./TheProfessionalResourcesList.vue?vue&type=style&index=0&id=6b8d9c66&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__